import { render, staticRenderFns } from "./MfaSetupModal.vue?vue&type=template&id=dc40d96a&scoped=true"
import script from "./MfaSetupModal.vue?vue&type=script&lang=js"
export * from "./MfaSetupModal.vue?vue&type=script&lang=js"
import style0 from "./MfaSetupModal.vue?vue&type=style&index=0&id=dc40d96a&prod&lang=scss&scoped=true"
import style1 from "./MfaSetupModal.vue?vue&type=style&index=1&id=dc40d96a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc40d96a",
  null
  
)

export default component.exports